/*
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2023-11-20 16:22:03
 */
import {loading} from '../../common/loading'
import {getUserInfoAjax2,appLogout,judgePassword,resetPassword} from '@/api/baseMsg';
import {removeToken} from '@/utils/auth'
import { resetRouter } from "@/router";
import { encryptedData } from "../../utils/JSEncrypt";
import { Toast } from "vant";

export default {
    name: "userInfo",
    data() {
                // 验证旧密码是否输入正确
                const validateOldPassword = () => {
                    // console.log(value);
                    const params = {
                        userId: this.userid,
                        password: encryptedData(this.passFrom.oldPassword)
                    }
                    const passFlag = judgePassword(params).then(res=> {
                        return res.data
                    })
                    return passFlag
                };
                // 验证新密码是否符合格式
                const validatePass = () => {
                    const regExp = /^.*(?=.{8,26})(?=.*\d)(?=.*[A-Z]{1,})|(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/;
                    if (this.passFrom.newPassword === "") {
                        return false
                    } else if (regExp.test(this.passFrom.newPassword) === false) {
                        return false
                    } else {
                        return true
                    }
                };
                // 验证新密码是否和旧密码一致
                const oldPwdOrNewPwd = () => {
                    if (this.passFrom.newPassword === this.passFrom.oldPassword) {
                        return false
                    } else {
                        return true
                    }
                };
                // 验证确认新密码是正确
                const validatePasswordVerify = () => {
                    if (this.passFrom.newPasswordVerify !== this.passFrom.newPassword) {
                      return false
                    } else {
                      return true
                    }
                  };
        return {
            userName: '',
            description:'',
            openId:'',
            showPass:false,
            userid:'',
            passFrom: {
                username:'',
                oldPassword:'',
                newPassword:'',
                newPasswordVerify:''
            },
            passFromRule:{
                oldPassword:[
                    { required: true, message: '请输入旧密码'},
                    {validator:validateOldPassword,message:'旧密码输入错误'}
                ],
                newPassword:[
                    { required: true, message: '请输入新密码'},
                    { validator: validatePass, message:'请输入8到26的密码，包含数字，字母，特殊字符' },
                    { validator: oldPwdOrNewPwd, message:'新密码不能和旧密码一致' }
                ],
                newPasswordVerify:[
                    { required: true, message: '确认新密码不能为空'},
                    { validator: validatePasswordVerify, message:'两次密码不一致'}
                ]
            },
            passwordType1:'password',
            passwordType2:'password',
            passwordType3:'password',
            formKey:0,
            outUserName: ''
        }
    },
    created() {
        this.checkLogin()
        this.init()
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1)
        },
        checkLogin() {
            const loginType = this.$store.state.login.loginType;
            if(loginType == 1) {
                // 小程序登录
                loading(true)
                getUserInfoAjax2().then(res=> {
                if(res.code == 200) {
                    if(!res.data.openId){
                        resetRouter()
                        removeToken()
                        this.$router.push({ path: '/login'});
                        // location.reload();
                    }
                }
                    loading(false)
                })
            }
        },
        init() {
            getUserInfoAjax2().then(res=> {
                if(res.code == 200) {
                    this.userid = res.data.id
                    this.passFrom.username = res.data.userName
                    this.userName = res.data.userName
                    this.description = res.data.description
                    this.openId = res.data.openId
                }
            })
        },
        tuichuBefore() {
            this.$dialog.confirm(
                {message: "是否注销登录?"}
            ).then(() => {
                this.tuichu();
            }).catch(() => {});
        },
        tuichu() {
            loading(true)
            const loginType = this.$store.state.login.loginType;
            if(loginType == '1') {
                const params = {
                    userName: this.userName
                }
                appLogout(params).then(res=> {
                    if(res.code == 200) {
                        resetRouter()
                        removeToken()
                        // location.reload();
                    }
                })
                this.$router.push({ 
                    path: '/login',
                    query:{
                        openId:this.openId,
                        code:300,
                        time:new Date().getTime()
                    }
                })
            }else {
                resetRouter()
                removeToken()
                this.$router.push({ path: '/loginOld'});
                // location.reload();
            }
            loading(false)
        },
        switchPasswordType(val) {
            switch (val) {
                case '1':
                    this.passwordType1 = this.passwordType1 === 'password' ? 'text' : 'password'
                    break
                case '2':
                    this.passwordType2 = this.passwordType2 === 'password' ? 'text' : 'password'
                    break
                case '3':
                    this.passwordType3 = this.passwordType3 === 'password' ? 'text' : 'password'
                    break
            }
            
        },
        editPassBefore() {
            this.passFrom.oldPassword = ''
            this.passFrom.newPassword = ''
            this.passFrom.newPasswordVerify = ''
            this.formKey ++
            this.showPass = true
        },
        onSubmit() {
            loading(true)
            const params = {
                userId:this.userid,
                oldPassword:encryptedData(this.passFrom.oldPassword),
                newPassword:encryptedData(this.passFrom.newPassword)
            }
            resetPassword(params).then(res=> {
                if (res.data) {
                    this.showPass = false
                    setTimeout(()=> {
                        Toast.success('密码修改成功')
                    },500)
                  } else {
                    Toast.fail('密码修改失败')
                  }
                  loading(false)
            })
        }
    }

}
